import { render, staticRenderFns } from "./payroll.vue?vue&type=template&id=0595598a&scoped=true"
import script from "./payroll.vue?vue&type=script&lang=ts"
export * from "./payroll.vue?vue&type=script&lang=ts"
import style0 from "./payroll.vue?vue&type=style&index=0&id=0595598a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0595598a",
  null
  
)

export default component.exports